import React from 'react';
import withClickOutside from '../../../hoc/withClickOutside';
import cancelEvent from '../../../services/mini/cancelEvent';

class ComboBoxList extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.closeComboBox = this.closeComboBox.bind(this);
    }

    handleClickOutside(e) {
        let el = e.target;
        if (!el.className.indexOf('oc_tag_list') >= 0) {
            this.props.onOutsideClick(e);
        }
    }

    closeComboBox(e) {
        cancelEvent(e);
        this.props.closeCompoBoxCb(e);
    }

    render() {
        const {
            opened,
            values,
            valueKey,
            valueName,
            selectValue,
            renderItem,
            selectedValueText,
            listMaxHeight,
            listItemCount,
            height,
            noItemsFoundMessage,
            keyboardSelectedItemId
        } = this.props;

        let classes = 'combo-box_list';

        if (opened) {
            classes += ' opened';
        }

        if (listItemCount !== undefined) {
            classes += ` item-${listItemCount}`;
        } else {
            if (values) {
                if (values.length <= 3) {
                    classes += ' item-' + values.length;
                } else if (values.length === 4) {
                    classes += ' item-4';
                } else {
                    classes += ' item-4 and-more ' ;
                }
            }
        }



        const style = {};

        if (listMaxHeight) {
            style.maxHeight = listMaxHeight;
        }

        if (height) {
            style.maxHeight = height;
            style.minHeight = height;
            style.height = height;
        }

        return (
            <div className={classes} style={style}>
                {values && values.map((val) => {
                    let text = valueName ? val[valueName] : val;
                    let isSelected;

                    if (selectedValueText && text) {
                        isSelected = selectedValueText.toLowerCase() === text.toLowerCase();
                    }

                    const id = valueKey ? val[valueKey] : val;

                    return <div key={id}
                        data-cb-item-id={id}
                        className={`combo-box_list_item ${isSelected && 'selected'} ${val.disabled && 'combo-box_list_item_disabled'} ${keyboardSelectedItemId === id && 'selected-with-keyboard'}`}
                        onClick={(e) => {
                            if (!val.disabled) {
                                selectValue(val, e);
                            } else {
                                cancelEvent(e);
                            }
                        }}>
                        <div className={`combo-box_list_item_text`}>
                            {renderItem ?
                                renderItem(val, true, this.closeComboBox) :
                                text
                            }
                        </div>
                    </div>;
                })}
                {noItemsFoundMessage && <div className="combo-box_list_item no-items">
                    <div className="combo-box_list_item_text">
                        {noItemsFoundMessage}
                    </div>
                </div>}
            </div>
        );
    }
}

export default withClickOutside(ComboBoxList);